import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';
import DomainCard from './DomainCard';

const SidebarContainer = styled(motion.aside)`
  padding: 2rem;
  background: rgba(10, 10, 18, 0.8);
  backdrop-filter: blur(20px);
  border-left: 1px solid rgba(255, 255, 255, 0.1);
  min-height: 100vh;
  
  @media (max-width: 1023px) {
    border-left: none;
    border-top: 1px solid rgba(255, 255, 255, 0.1);
    min-height: auto;
    order: 2;
  }
`;

const SidebarTitle = styled(motion.h2)`
  font-size: 1.5rem;
  font-weight: 700;
  margin-bottom: 2rem;
  background: linear-gradient(135deg, #00d4ff, #8a2be2);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  text-align: center;
  
  @media (max-width: 1023px) {
    margin-bottom: 1.5rem;
  }
`;

const DomainsGrid = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  
  @media (max-width: 1023px) {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
    gap: 1rem;
  }
`;

const Sidebar = () => {
  const domains = [
    {
      domain: 'Freshy.ai',
      tagline: 'Ideal for AI freshness tracking, supply chain tech, or apps focused on newness.',
      url: 'https://freshy.ai'
    },
    {
      domain: 'Spendy.ai',
      tagline: 'Perfect for AI-driven finance, budgeting, and spending assistants.',
      url: 'https://spendy.ai'
    },
    {
      domain: 'Superpositions.ai',
      tagline: 'Great for quantum computing startups, AI research platforms, and futuristic tech.',
      url: 'https://superpositions.ai'
    },
    {
      domain: 'Syngen.ai',
      tagline: 'Versatile for synthetic biology, AI-generated content, and next-gen intelligence.',
      url: 'https://syngen.ai'
    }
  ];

  return (
    <SidebarContainer
      initial={{ opacity: 0, x: 100 }}
      animate={{ opacity: 1, x: 0 }}
      transition={{ duration: 0.8, delay: 0.3 }}
    >
      <SidebarTitle
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, delay: 0.5 }}
      >
        Premium AI Domains
      </SidebarTitle>
      
      <DomainsGrid>
        {domains.map((domain, index) => (
          <DomainCard
            key={domain.domain}
            domain={domain.domain}
            tagline={domain.tagline}
            url={domain.url}
            index={index}
          />
        ))}
      </DomainsGrid>
    </SidebarContainer>
  );
};

export default Sidebar; 